import React from 'react'
import PropTypes from 'prop-types'

const ListeMusiques = ({ children, isOpen, onToggle }) => {
    return (
        <div className="flex flex-col gap-4 p-4 md:p-6 mx-4 my-4 md:mr-10 md:ml-4 md:my-10 bg-[#272727] rounded-lg shadow-lg text-center md:flex-shrink-0">
            <div
                className="flex flex-row justify-between items-center cursor-pointer md:cursor-default"
                onClick={onToggle}
            >
                <h1 className="text-white font-semibold text-2xl mb-2 font-poppins flex-1">Musique des Worlds</h1>
                <span className="md:hidden text-gray-400 text-lg select-none">{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`flex flex-col gap-4 overflow-y-auto ${isOpen ? '' : 'hidden md:flex'}`}>
                {children}
            </div>
        </div>
    )
}

ListeMusiques.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
}

ListeMusiques.defaultProps = {
    children: null,
    isOpen: true,
    onToggle: () => {},
};

export default ListeMusiques;